import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-elektrisch-rijden',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconElektrischRijden {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m24.45 33-6.05-3.86c-.67-.4-1.5.13-1.48.95l.05 3.07-4.52-2.95c-.48-.28-1.09-.1-1.36.42-.27.51-.09 1.16.39 1.45l6.03 3.8c.67.39 1.49-.12 1.48-.94l-.02-3.06 4.51 2.99c.48.28 1.09.1 1.36-.42s.09-1.16-.39-1.45"/>
  <path d="M35.29 9h-1.51l-2.11-5.93C31.07 1.24 29.36.01 27.41 0H8.7C6.76.11 5.05 1.34 4.45 3.15L2.29 9H.71C.32 9 0 9.42 0 9.94V11c0 .55.45 1 1 1h.18S0 14.21 0 15.01V29.4c0 .89.72 1.61 1.61 1.61H4.4c.89 0 1.61-.72 1.61-1.61v-3.39h24v3.39c0 .89.72 1.61 1.61 1.61h2.79c.89 0 1.61-.72 1.61-1.61V15.01c0-.78-1.15-3.01-1.15-3.01h.14c.55 0 1-.45 1-1V9.94c0-.52-.32-.94-.71-.94ZM6.5 22C5.12 22 4 20.89 4 19.53s1.12-2.47 2.5-2.47S9 18.17 9 19.53 7.88 22 6.5 22m15.51-1.01H14c-.55 0-.99-.45-.99-.99 0-.55.45-.99.99-.99h8.01c.55 0 .99.45.99.99 0 .55-.45.99-.99.99m7.49.94c-1.37 0-2.49-1.1-2.49-2.46s1.12-2.46 2.49-2.46 2.49 1.1 2.49 2.46-1.12 2.46-2.49 2.46M3.31 12l3.01-8.15v-.03l.02-.03c.33-.99 1.3-1.71 2.42-1.78H27.4c1.08 0 2.04.69 2.38 1.74l2.94 8.26H3.31Z"/>
</svg>

    );
  }
}
